export const convertToFinnishId = (id: string) => {
  const formattedId = id.slice(0, -1) + '-' + id.slice(-1)
  return formattedId
}
